import { isNil } from 'lodash';

import { defaultEventCreateDialogEditorOutput } from '../default-event-create-dialog-editor-output';
import { EventCreateDialogEditorOutput } from '../event-create-dialog-editor-output';
import { EventCreateDialogFormType } from '../event-create-dialog-form-type';

export const formToEventCreateDialogEditorOutput = (
  formType: EventCreateDialogFormType | undefined | null,
): EventCreateDialogEditorOutput => {
  if (isNil(formType)) {
    return defaultEventCreateDialogEditorOutput;
  }

  return {
    startTime: formType.startTime ?? '',
    endTime: formType.endTime ?? '',
    isRepeating: formType.isRepeating ?? false,
    rrule: formType.rrule ?? '',
    repeatEnd: formType.repeatEnd ?? '',
    repeatEndDate: formType.repeatEndDate ?? '',
    extendScheduleNumDays: formType.extendScheduleNumDays ?? 90,
    assignedUserId: formType.assignedUserId ?? '',
    assignedBackupUserId: formType.assignedBackupUserId ?? '',
  };
};
